import { type ChartData, type ChartOptions } from 'chart.js';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export type ChartContext = any;

export enum CHART_TYPE {
  LINE = 'line',
  BAR = 'bar'
}

export type AmountTooltipLabelData = {
  saveflowAmount: string;
  extraPaymentsAmount: string;
  payflowPlusProcessingAmount: string;
};

export type CountTooltipLabelData = {
  saveflowCount: string;
  extraPaymentsCount: string;
  payflowPlusProcessingCount: string;
  summary: string;
};

export type BarChartOptions = ChartOptions<'bar'>;
export type LineChartOptions = ChartOptions<'line'>;
